
import Vue from "vue";
import HeaderDropDownFilter, { OptionItem } from "@/components/BaseHeaderDropDownFilter.vue";

export type FilterCondition = {
  alertType?: string;
  status?: string;
  toiletType?: string;
};

export type DataType = {
  filterCondition: FilterCondition;
  alertTypeOptions: Array<OptionItem>;
  statusOptions: Array<OptionItem>;
  toiletTypeOptions: Array<OptionItem>;
};

export default Vue.extend({
  name: "ActiveAlertLongStayListHeader",

  components: {
    HeaderDropDownFilter,
  },

  data(): DataType {
    return {
      filterCondition: {
        alertType: undefined,
        status: undefined,
        toiletType: undefined,
      },
      alertTypeOptions: [
        {
          label: "長時間利用",
          value: "長時間利用",
        },
      ],
      statusOptions: [
        {
          label: "発生",
          value: "発生",
        },
        {
          label: "解決済",
          value: "解決済",
        },
      ],
      toiletTypeOptions: [
        {
          label: "女性トイレ",
          value: "FOR_WOMAN",
        },
        {
          label: "男性トイレ",
          value: "FOR_MAN",
        },
        {
          label: "多目的トイレ",
          value: "MULTI_PURPOSE",
        },
        {
          label: "共用",
          value: "UNISEX",
        },
      ],
    };
  },

  methods: {
    updateFilterConditionAndSearch(): void {
      this.$emit("update-filter-condition", this.filterCondition);
      this.$emit("search");
    },
  },
});
